<template>
    <!-- Старая версия -->
    <!-- <v-layout align-end justify-center my-2>
        <img class="logo-img" :src="require('@/assets/animate-logo-white.svg')"/>
        
        <p class="ma-0 logo-txt">EG pilots</p>
    </v-layout> -->
    <!--<p class="ma-0 display-3 logo-txt font-weight-bold">EG pilots</p>-->
    <!--  -->
    <v-container class="d-flex align-end justify-sm-center flex-wrap">
        <img class="logo-img" :src="require('@/assets/animate-logo-white.svg')"/>
        <p class="ma-0 logo-txt">EG pilots</p>
    </v-container>
</template>
<script>
    export default {}
</script>

<style scoped>
    .logo-img {
      width: 120px;
      height: 120px;
    }

    .logo-txt {
      font-size: 3.5rem;
      font-family: "ElementalEnd";
    }
</style>
